<!-- eslint-disable max-len -->
<template>
  <div
    id="form-search-popover"
    class="h-100"
  >
    <div
      :class="{ 'studio-page-header-long' : !is_sidebar_minimized }"
      class="studio-page-header"
      style="padding-bottom: 0 !important; padding-top: 15px !important; height: 110px">
      <div class="d-flex apps">
        <img
          class="back-to-list-apps"
          src="@/assets/icon/arrow-left.svg"
          @click="$router.push('/setting/application')"
        >
        <img
          v-if="modeDetail === 'application' && urlIcon"
          :src="urlIcon"
          class="m__r--5"
          width="25">
        <div
          v-if="modeDetail === 'application'"
          class="title-apps">
          {{ application.appName }} <br>
          <!-- <div class="title-id-tab-studio">{{ appId }}</div> -->
        </div>
        <div
          v-if="modeDetail === 'group'"
          class="title-apps m__t--3">
          {{ dataGroup ? dataGroup.name : '' }} <br>
          <!-- <div class="title-id-tab-studio">{{ dataGroup ? dataGroup.id : '' }}</div> -->
        </div>
        <div class="btn-action-experience display-inline pull-right">
          <i
            id="configPopover"
            class="fa fa-ellipsis-v fa-lg cursor-pointer pull-right m__t--10 m__l--20"/>
        </div>
      </div>
      <div
        :class="modeDetail === 'group' ? 'm__t--35' : 'm__t--37'"
        class="d-flex">
        <div
          :class="{'tab-experience-manager-active' : tabSelected === 'general'}"
          class="tab-experience-manager m__r--35"
          @click="selectTab('general')">
          GENERAL
        </div>
        <div
          v-if="modeDetail === 'application' && typeMode === 'native'"
          :class="{'tab-experience-manager-active' : tabSelected === 'pages'}"
          class="tab-experience-manager"
          @click="selectTab('pages')">
          PAGES
        </div>
      </div>
    </div>

    <div
      v-if="tabSelected === 'general' && modeDetail === 'application'"
      class="studio-page-content">
      <b-row>
        <b-col md="11">
          <div class="card-field-container">
            <h4>GENERAL</h4>

            <b-row class="form-edit">
              <b-col cols="4">
                <div class="bordered-app-detail">
                  <h4>Icon</h4>
                  <j-upload
                    :accepted-file-type="['jpg', 'png', 'jpeg', 'bmp', 'xlsx', 'docx']"
                    :api-token="api"
                    :grid-cols="12"
                    :label-name="'Image that represents an application '"
                    :img-default="urlIcon"
                    :url-upload="url_upload"
                    class="upload-blank-application"
                    @url="getIcon"/>
                </div>
              </b-col>
              <b-col cols="8">
                <div class="bordered-app-detail">
                  <h4>General Information</h4>
                  <b-form-group :class="{'error-input' : $v.application.appName.$error}">
                    <label for="appName"> Application Name </label>
                    <j-input
                      id="appName"
                      v-model="$v.application.appName.$model"
                      placeholder="Enter application name here"/>
                  </b-form-group>
                  <b-form-group
                    v-show="typeMode === 'hyperlink'"
                    :class="{'error-input' : $v.application.appUrl.$error}">
                    <label for="appUrl"> Url </label>
                    <j-input
                      id="appUrl"
                      v-model="$v.application.appUrl.$model"
                      placeholder="Enter url"/>
                  </b-form-group>
                  <b-form-group :class="{'error-input' : $v.application.descName.$error}">
                    <label for="descName"> Description </label>
                    <j-textarea
                      id="descName"
                      v-model="$v.application.descName.$model"
                      :disabled="false"
                      placeholder="Enter application description here"/>
                  </b-form-group>
                  <b-form-group>
                    <label> Group Application </label>
                    <j-single-select
                      v-model="selectedGroup"
                      :options="groupOptions"
                      :placeholder="'Select Group'"
                      value-format="object"
                    />
                  </b-form-group>
                  <b-form-group v-show="typeMode === 'hyperlink'">
                    <label> Open Hyperlink in App Browser (Mobile) </label>
                    <j-toggle v-model="$v.application.open_hyperlink_in_app_browser.$model"/>
                  </b-form-group>
                  <b-form-group v-show="typeMode === 'hyperlink'">
                    <label> Use Token </label>
                    <j-toggle v-model="$v.application.useToken.$model"/>
                  </b-form-group>
                  <div
                    v-if="application.is_offline_mode"
                    class="local-storage">
                    <img
                      src="@/assets/logo/offline-mode.png"
                      height="16">
                    Local Storage Support
                  </div>
                </div>

                <div
                  v-show="typeMode === 'native'"
                  class="bordered-app-detail m__t--10">
                  <h4>Search Menu</h4>
                  <label>A search bar or search box in order to look up menu or page</label>
                  <j-toggle
                    v-model="application.search_menu"
                    class="toggle-search-menu"/>
                </div>
              </b-col>
            </b-row>

            <div class="text-right m__t--20">
              <b-button
                class="btn blue"
                @click="updateGeneral">
                Update
              </b-button>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>

    <div
      v-if="tabSelected === 'pages' && showContainerPages"
      class="studio-page-content d-flex">
      <div
        id="sidebar-app"
        class="content-left-pages-studio-apps"
      >
        <div class="head-pages">Sidebar</div>
        <div class="list-pages">
          <div
            v-for="valParent in isParent"
            :key="valParent.id"
            class="row-pages">
            <div
              :class="{ 'pages-active' : selectedPage && selectedPage.id === valParent.id }"
              class="row-pages-inner d-flex"
              @click="showComponentPages(valParent)">
              <img
                :src="selectedPage && selectedPage.id === valParent.id ? valParent.icon_active : valParent.icon_white"
                height="16"
                width="16">
              <div class="m__l--15">{{ valParent.name.toUpperCase() }}</div>
            </div>

            <div
              v-for="valChild in getSubPageByParent(valParent.id)"
              :key="valChild.id"
              :class="{ 'pages-active' : selectedPage && selectedPage.id === valChild.id }"
              class="row-pages-child">
              <div
                class="d-flex"
                @click="showComponentPages(valChild)">
                <img
                  :src="selectedPage && selectedPage.id === valChild.id ? valChild.icon_active : valChild.icon_white"
                  height="16"
                  width="16">
                <div class="m__l--15">{{ valChild.name.toUpperCase() }}</div>
              </div>
            </div>
            <div
              v-if="valParent.type === 'menu' && !isFormActive"
              class="m__t--10 m__b--10"
              @click="createSubPage(valParent.id)">
              <span
                :id="`pageCreateSub-${valParent.id}`"
                class="row-pages-child">
                <i class="fa fa-plus"/>
                Add Submenu
              </span>
            </div>

            <!-- Popover create sub page -->
            <b-popover
              :target="`pageCreateSub-${valParent.id}`"
              triggers="manual"
              placement="bottom"
              container="sidebar-app"
            >
              <h3>Add Sub Menu</h3>
              <j-form-page
                :ref="`formSubPage-${valParent.id}`"
                :is-popover="true"
                :mode="'createSub'"
                :icon-options="iconOptions"
              />
              <div class="d-flex justify-content-end mt-3">
                <button
                  class="btn-border mr-2"
                  @click="closeCreateSubPage">
                  Close
                </button>
                <button
                  class="btn-blue"
                  @click="savePage(valParent.id)">
                  Save
                </button>
              </div>
            </b-popover>
          </div>
          <div
            class="m__t--10 m__b--10"
            @click="createParentPage">
            <span
              id="pageCreate"
              class="row-pages">
              <i class="fa fa-plus"/>
              Add Menu
            </span>
          </div>
        </div>

        <!-- Popover create page -->
        <b-popover
          :target="'pageCreate'"
          triggers="manual"
          placement="bottom"
          container="sidebar-app"
        >
          <h3>Add Menu</h3>
          <j-form-page
            ref="formPage"
            :is-popover="true"
            :icon-options="iconOptions"
          />
          <div class="d-flex justify-content-end mt-3">
            <button
              class="btn-border mr-2"
              @click="closeCreateParentPage">
              Close
            </button>
            <button
              class="btn-blue"
              @click="savePage()">
              Save
            </button>
          </div>
        </b-popover>
      </div>
      <div class="content-right-pages-studio-apps">
        <j-pages-setting
          v-if="showComponent"
          :data-page="selectedPage"
          @reload="getApplicationDetail"/>
      </div>
    </div>

    <div
      v-if="tabSelected === 'pages' && !showContainerPages"
      class="d-flex align-items-center justify-content-center"
      style="height: 400px">
      <div class="lds-ellipsis"><div/><div/><div/><div/></div>
    </div>

    <div
      v-if="tabSelected === 'general' && modeDetail === 'group'"
      class="studio-page-content">
      <b-row>
        <b-col md="10">
          <div class="card-field-container">
            <h4>Properties</h4>

            <b-form-group :class="{'error-input' : $v.group.name.$error}">
              <label> Group Name </label>
              <j-input
                v-model="$v.group.name.$model"
                placeholder="Enter group name here"/>
            </b-form-group>
            <b-form-group :class="{'error-input' : $v.group.description.$error}">
              <label> Description </label>
              <j-textarea
                v-model="$v.group.description.$model"
                :disabled="false"
                placeholder="Enter group description here"/>
            </b-form-group>

            <b-button
              class="btn blue"
              @click="updateGeneral">
              Update
            </b-button>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="10">
          <div class="card-field-container">
            <h4>Application</h4>

            <v-client-table
              v-show="load_first"
              :data="data_apps"
              :columns="columns"
              :options="table_options"
              class="jTable group-application-table">
              <div
                slot="beforeFilter"
                class="custom-search">
                <b-form inline>
                  <b-button
                    class="btn grey btn-import-form m__r--5"
                    @click="isModalAppOpen(true)">
                    <i class="fa fa-plus fa-lg"/> Add
                  </b-button>
                  <b-form
                    inline
                    @keypress.13.prevent="filter(filter_data)">
                    <j-select
                      v-model="select_type"
                      :options="options_search"
                      placeholder="Filter By"
                      class="m__r--5"/>
                    <b-form-input
                      v-model="filter_data"
                      placeholder="Search"
                      style="width: 250px; height: 35px"/>
                  </b-form>
                </b-form>
              </div>

              <div
                slot="id"
                slot-scope="props">
                {{ props.row.id }}
              </div>

              <div
                slot="icon"
                slot-scope="props">
                <img
                  v-if="props.row.icon"
                  :src="props.row.icon"
                  width="32">
              </div>

              <div
                slot="name"
                slot-scope="props">
                {{ props.row.name }}
              </div>

              <div
                slot="delete"
                slot-scope="props">
                <i
                  class="fa fa-trash fa-lg cursor-pointer"
                  @click="deleteMapping(props.row.id)"/>
              </div>
            </v-client-table>
            <jLoadingTable v-if="!load_first"/>
          </div>
        </b-col>
      </b-row>
    </div>

    <b-popover
      ref="configPopoverRef"
      :show.sync="configPopoverShow"
      target="configPopover"
      container="studio-page-header"
      placement="left">
      <div
        class="form-ui-opt"
        @click="deleteApps">
        Delete {{ modeDetail === 'group' ? 'Group' : 'Application' }}
      </div>
      <div
        v-if="modeDetail === 'application'"
        class="form-ui-opt"
        @click="goToV2"
      >
        Try New UI
      </div>
    </b-popover>

    <b-modal
      ref="appModal"
      class="mod-form modal-app-type"
      centered
      no-close-on-esc
      no-close-on-backdrop
    >
      <j-modal-mapping-apps-group
        @modal-open="isModalAppOpen"
        @data-created="getGroupApplicationList"
      />
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable import/no-extraneous-dependencies, no-nested-ternary, max-len, no-unused-vars, no-console */
import { mapActions, mapState } from 'vuex';
import { required, requiredIf } from 'vuelidate/lib/validators';
// Components
import jUpload from '@/components/file-uploader/jUpload';
// import jPrivilegeSetting from '@/views/setting/jPrivilegeSetting';
// import jModalCreateGroup from '@/views/setting/jModalCreateGroup';
import jFormPage from '@/views/setting/jFormPage';
import jPagesSetting from '@/views/pages/jPagesSetting';
import jModalMappingAppsGroup from '@/views/setting/jModalMappingAppsGroup';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';

export default {
  name: 'JApplicationDetail',
  components: {
    jUpload,
    // jPrivilegeSetting,
    // jModalCreateGroup,
    jFormPage,
    jPagesSetting,
    jModalMappingAppsGroup,
    jLoadingTable,
  },
  validations() {
    return {
      application: {
        appName: { required },
        descName: { required },
        appUrl: { required: requiredIf(() => this.typeMode === 'hyperlink') },
        is_offline_mode: {},
        open_hyperlink_in_app_browser: {},
        useToken: {},
      },
      group: {
        name: { required },
        description: { },
      },
    };
  },
  data() {
    return {
      tabSelected: 'general',
      typeMode: '',
      modeDetail: '',
      application: {
        appName: null,
        descName: null,
        appUrl: null,
        is_offline_mode: false,
        open_hyperlink_in_app_browser: false,
        useToken: false,
        search_menu: false,
      },
      selectedPage: null,
      selectedGroup: null,
      dataGroup: null,
      showComponent: false,
      showContainerPages: false,
      groupOptions: [],
      idPageCreated: null,
      group: {
        name: null,
        description: null,
      },
      api: JSON.parse(localStorage.getItem('Token')).value,
      urlIcon: null,
      urlIconLauncher: null,
      iconOptions: [],
      icons: [],
      isFormActive: false,
      listPages: [],
      pageMode: 'create',
      pageId: null,
      parentId: null,
      orderPage: null,
      appId: null,
      groupRelationId: null,
      groupAppId: null,
      itemsBreadcrumb: [{ text: 'APPLICATION', to: '/setting/application' }],
      configPopoverShow: false,

      // Apps
      data_apps: [],
      load_first: false,
      filter_data: '',
      select_type: 'name',
      options_search: [
        {
          text: 'Name',
          value: 'name',
        },
      ],
      columns: ['id', 'icon', 'name', 'delete'],
      table_options: {
        headings: {
          id: 'ID',
          icon: 'LOGO',
          name: 'NAME',
          delete: '',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        sortable: [],
        filterable: true,
        perPage: 10,
        perPageValues: [10, 50, 100, 500, 1000],
      },
    };
  },
  computed: {
    ...mapState('jStoreSetting', ['application_detail', 'pages_list', 'group_applications_list', 'group_relations_list', 'is_sidebar_minimized']),
    ...mapState('jStorePrivilege', ['organigram_detail']),

    isParent() {
      return this.listPages.filter(valParent => valParent.parent_id === 0 || valParent.parent_id === null)
        .sort((a, b) => a.order - b.order);
    },
    url_upload() {
      return `${process.env.GATE_URL}app/api/v3/pro/tool/uploadMedia`;
    },
  },
  watch: {
    application_detail(val) {
      this.application.appName = val.name;
      this.application.descName = val.description;
      this.application.appUrl = val.hyperlink;
      this.application.is_offline_mode = val.is_offline_mode || false;
      this.application.open_hyperlink_in_app_browser = val.is_open_hyperlink_in_app_browser || false;
      this.application.search_menu = val.is_show_search_menu || false;
      this.application.useToken = val.type_platform === 5;
      this.urlIcon = val.icon;
      this.urlIconLauncher = val.icon_launcher;
      this.typeMode = val.type_platform === 1 ? 'native' : 'hyperlink';

      this.appId = val.id;

      // eslint-disable-next-line
      // const dataExist = this.itemsBreadcrumb.filter(e => e.text.toUpperCase() === val.name.toUpperCase());
      // if (dataExist.length === 0) {
      //   this.itemsBreadcrumb.push({ text: val.name.toUpperCase(), active: true });
      // }

      const param = {
        params: {
          page: 1,
          limit: 0,
          column: 'id',
          sort: 'asc',
          query: '',
          query_type: '',
        },
      };
      this.actionGetGroupRelationsList(param);
    },
    pages_list(val) {
      this.listPages = val;
    },
    group_applications_list(val) {
      if (this.$route.params.groupId) {
        this.dataGroup = val.find(group => group.id === Number(this.$route.params.groupId));
        if (this.dataGroup) {
          this.group.name = this.dataGroup.name;
          this.group.description = this.dataGroup.description;

          this.data_apps = this.dataGroup.application;
          this.load_first = true;
        }
      }

      const res = val.find(group => group.id === Number(this.groupAppId));
      this.selectedGroup = res || null;

      this.groupOptions = [];
      val.forEach((lab) => {
        if (lab.id !== 0) {
          this.groupOptions.push({
            text: lab.name,
            id: lab.id,
            is_delete: false,
          });
        }
      });
    },
    group_relations_list(val) {
      const filtered = val.find(relation => relation.application_id === this.appId);
      if (filtered) {
        this.groupAppId = filtered.group_application_id;

        const res = this.group_applications_list.find(group => group.id === Number(this.groupAppId));
        this.selectedGroup = res || null;
      }
    },
    tabSelected(val) {
      if (val === 'pages') {
        const findFirstPageVisible = this.isParent.find(f => f.type === 'visible');
        this.selectedPage = findFirstPageVisible || null;
        if (findFirstPageVisible) {
          setTimeout(() => {
            this.showComponent = true;
          }, 500);
        }
      }
    },
  },
  created() {
    if (this.$route.params.type !== 'group') {
      this.modeDetail = 'application';
      this.getApplicationDetail();
    } else {
      this.modeDetail = 'group';
    }
    this.getGroupApplicationList();

    this.initIconList();
    if (localStorage.getItem('userCompanyId')) {
      this.actionDetailOrganigram({ user_company_id: Number(localStorage.getItem('userCompanyId')) });
    }
  },
  methods: {
    ...mapActions('jStoreSetting', ['actionGetApplicationDetail',
      'actionUpdateApplication',
      'actionDeleteApplication',
      'actionGetPagesList',
      'actionCreatePage',
      'actionUpdatePage',
      'actionDeletePage',
      'actionGetGroupApplicationsList',
      'actionGetGroupApplicationsDetail',
      'actionGetGroupRelationsList',
      'actionUpdateGroupApplication',
      'actionDeleteGroupApplication',
      'actionDeleteGroupRelation',
      'actionGetApplicationsList',
      'actionGetListIcons']),
    ...mapActions('jStorePrivilege', ['actionCreatePrivilegePage', 'actionDetailOrganigram']),

    selectTab(tab) {
      this.tabSelected = tab;
      if (tab === 'pages') {
        setTimeout(() => {
          this.showContainerPages = true;
        }, 2000);
      } else {
        this.showContainerPages = false;
      }
    },

    filter(val) {
      this.data_apps = this.dataGroup.application.filter(app =>
        app.name.toUpperCase().includes(val.toUpperCase()));
    },

    isModalAppOpen(val) {
      if (val) {
        this.$refs.appModal.show();
      } else {
        this.$refs.appModal.hide();
      }
    },

    showComponentPages(data) {
      this.showComponent = false;
      this.selectedPage = data;
      setTimeout(() => {
        this.showComponent = true;
      }, 500);
    },

    getApplicationDetail(hideComponent) {
      if (hideComponent) { this.showComponent = false; }
      const applicationId = this.$route.params.applicationId;
      const param = {
        params: {
          page: 1,
          limit: 0,
          column: 'id',
          sort: 'asc',
          query: '',
          query_type: '',
        },
      };
      this.actionGetPagesList({ applicationId, param }).then((res) => {
        if (this.idPageCreated) {
          this.showComponent = false;
          const selected = res.data.filter(r => r.id === this.idPageCreated)[0];
          this.selectedPage = selected;
          this.idPageCreated = null;

          setTimeout(() => {
            this.showComponent = true;
          }, 500);
        }
      });
      this.actionGetApplicationDetail({ applicationId, param });
    },
    getGroupApplicationList() {
      const param = {
        params: {
          page: 1,
          limit: 0,
          column: 'id',
          sort: 'asc',
          query: '',
          query_type: '',
        },
      };
      this.actionGetGroupApplicationsDetail(param);
    },
    getSubPageByParent(parentId) {
      return this.listPages.filter(page => page.parent_id === parentId)
        .sort((a, b) => a.order - b.order);
    },
    async initIconList() {
      const params = {
        page: 1,
        limit: 100,
        column: 'id',
        sort: 'desc',
        query: '',
        query_type: '',
      };
      const res = await this.actionGetListIcons(params);
      if (!res.error) {
        this.iconOptions = res.data.map(val => ({
          name: val.name,
          label: val.name,
          text: val.name,
          id: val.id,
          icon_grey: val.icon_active,
          is_delete: false,
        }));
      }
    },
    parentChildLastOrder(parentId) {
      const childPages = this.listPages.filter(page => page.parent_id === parentId);
      if (childPages.length > 0) {
        const sortedChild = childPages.sort((a, b) => a.order - b.order);
        return sortedChild[sortedChild.length - 1].order;
      }
      const pageOrder = this.listPages.find(page => page.id === parentId).order;
      return pageOrder;
    },
    getIcon(data) {
      this.urlIcon = data;
    },
    createParentPage() {
      this.pageMode = 'create';
      if (this.pageId) this.closeCreateSubPage();
      this.$root.$emit('bv::show::popover', 'pageCreate');
    },
    createSubPage(id) {
      this.pageMode = 'createSub';
      this.closeCreateParentPage();
      if (this.pageId) {
        this.$refs[`formSubPage-${this.pageId}`][0].resetForm();
        this.$root.$emit('bv::hide::popover', `pageCreateSub-${this.pageId}`);
      }
      this.pageId = id;
      this.orderPage = this.parentChildLastOrder(id);
      this.$root.$emit('bv::show::popover', `pageCreateSub-${id}`);
    },
    createPage() {
      this.pageMode = 'create';
      this.isFormActive = true;
    },
    closeCreateParentPage() {
      this.$refs.formPage.resetForm();
      this.$root.$emit('bv::hide::popover', 'pageCreate');
    },
    closeCreateSubPage() {
      this.$refs[`formSubPage-${this.pageId}`][0].resetForm();
      this.$root.$emit('bv::hide::popover', `pageCreateSub-${this.pageId}`);
    },
    savePage(id) {
      const element = id ? this.$refs[`formSubPage-${id}`][0] : this.$refs.formPage;
      element.getData().then(async (data) => {
        const parameter = {
          application_id: this.application_detail.id,
          name: data.titlePage,
          type: data.selectedType,
          icon_id: data.selectedIcon.id,
          show_option: data.displayMode,
          type_platform: 1,
        };

        if (this.pageMode === 'create') {
          Object.assign(parameter, {
            order: 0,
            parent_id: 0,
          });
          const res = await this.actionCreatePage(parameter);
          if (!res.error) {
            this.$store.dispatch('jStoreNotificationScreen/toggleSuccess', res.message);
            this.idPageCreated = res.data.id;
            this.closeCreateParentPage();
            this.addPrivilegePage(res.data.id);
            this.getApplicationDetail();
          }
        } else if (this.pageMode === 'createSub') {
          Object.assign(parameter, {
            order: this.orderPage + 1,
            parent_id: this.pageId,
          });
          const res = await this.actionCreatePage(parameter);
          if (!res.error) {
            this.$store.dispatch('jStoreNotificationScreen/toggleSuccess', res.message);
            this.idPageCreated = res.data.id;
            this.closeCreateSubPage();
            this.addPrivilegePage(res.data.id);
            this.getApplicationDetail();
          }
        }
        this.isFormActive = false;
      });
    },
    async updateGeneral() {
      if (this.modeDetail === 'application') {
        this.$v.application.$touch();
        if (!this.urlIcon) {
          this.$store.dispatch('jStoreNotificationScreen/toggleProblem', 'Icon is required');
        } else if (!this.$v.application.$error) {
          const filtered = this.group_relations_list.find(relation =>
            relation.application_id === this.appId);
          if (filtered) {
            this.groupRelationId = filtered.id;
          }

          const applicationId = this.application_detail.id;
          const param = {
            name: this.application.appName,
            icon: this.urlIcon,
            icon_launcher: this.urlIconLauncher,
            description: this.application.descName,
            is_offline_mode: this.application.is_offline_mode,
            group_application_relation_id: this.groupRelationId ? this.groupRelationId : undefined,
            group_application_id: this.selectedGroup ? this.selectedGroup.id : undefined,
            type_platform: this.typeMode === 'hyperlink' ? (this.application.useToken ? 5 : 4) : 1,
            hyperlink: this.typeMode === 'hyperlink' ? this.application.appUrl : '',
            is_open_hyperlink_in_app_browser: this.application.open_hyperlink_in_app_browser,
            is_show_search_menu: this.application.search_menu,
          };
          const res = await this.actionUpdateApplication({ applicationId, param });
          if (res.error) {
            this.$store.dispatch('jStoreNotificationScreen/toggleProblem', res.message);
          }
        }
      } else {
        this.$v.group.$touch();
        if (!this.$v.group.$error) {
          const groupId = this.dataGroup.id;
          const param = {
            name: this.group.name,
            description: this.group.description,
          };
          const res = await this.actionUpdateGroupApplication({ groupId, param });
          if (res.error) {
            this.$store.dispatch('jStoreNotificationScreen/toggleProblem', res.message);
          }
        }
      }
    },
    openPageSetting(pageId) {
      const appIdHash = this.$route.params.applicationId;
      this.$router.push(`/setting/application/${appIdHash}/${this.application.appName}/page/${pageId}`);
    },
    addPrivilegePage(pageId) {
      if (this.organigram_detail.length > 0 && this.organigram_detail[0].id) {
        const params = {
          pages_id: Number(pageId),
          organigram_id: Number(this.organigram_detail[0].id),
        };
        this.actionCreatePrivilegePage(params);
      }
    },
    isModalCreateGroupOpen(val) {
      if (val) {
        this.$refs.createGroupModal.show();
      } else {
        this.getGroupApplicationList();
        this.$refs.createGroupModal.hide();
      }
    },
    deleteApps() {
      this.configPopoverShow = false;
      const name = this.modeDetail === 'application' ? this.application.appName : this.group.name;

      this.$swal({
        title: `Delete ${this.modeDetail === 'group' ? 'Group' : 'Application'}`,
        html: `Are you sure to delete ${this.modeDetail === 'group' ? 'Group' : 'Application'} "<span style="font-family: Poppins-Medium; font-size: 18px;">${name}</span>"?`,
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        confirmButtonColor: '#D2232A',
        cancelButtonColor: '#D2232A',
        titleColor: '#D2232A',
      }).then(async (result) => {
        if (result.value) {
          let res;
          if (this.modeDetail === 'application') {
            res = await this.actionDeleteApplication(this.application_detail.id);
          } else {
            res = await this.actionDeleteGroupApplication(this.dataGroup.id);
          }
          if (!res.error) {
            this.$router.push('/setting/application');
          }
        }
      });
    },
    deleteMapping(appId) {
      const text = 'Are you sure to delete?';
      this.$swal({
        title: 'Delete',
        text,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        confirmButtonColor: '#D2232A',
        cancelButtonColor: '#D2232A',
        titleColor: '#D2232A',
      }).then(async (result) => {
        if (result.value) {
          const param = {
            application_id: appId,
            group_application_id: this.dataGroup.id,
          };
          const res = await this.actionDeleteGroupRelation(param);
          if (!res.error) {
            this.getGroupApplicationList();
          }
        }
      });
    },

    goToV2() {
      this.$router.push(`/application-manager/general/${this.$route.params.applicationId}`);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/setting/jApplicationDetail.vue